import React from 'react';
import styles from './UnavialablePriorYearRMDModal.module.scss';
import { RMD_PRIOR_YEAR_UNAVAILABLE } from "../../../redux/modules/modals/modals.module";
import ButtonBeacon from "../../Beacon/ButtonBeacon";
const UnavialablePriorYearRMDModal = ({onClose}) => {
  return (
      <div className={styles["container-important-info"]}>
      <h1 className={styles["title"]}>Prior Year RMD Unavailable</h1>
      <div className={styles["sub-title"]}>
        <div className={styles["calculator-info"]}>
          Based on the date of birth entered, you would have not been required to take an RMD last year.
        </div>
        <div>
          <div className={styles["buttonModal"]}>
            <div className={styles["button-object"]}>
              <ButtonBeacon onClick={() => onClose(RMD_PRIOR_YEAR_UNAVAILABLE)} label={'Close'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnavialablePriorYearRMDModal;
